import { ActionTypes, DEVICE_TYPES } from './constants';

const defaultState = {
    deviceType: DEVICE_TYPES.Mobile, // String: represents device type
    isMobile: true, // default to mobile
    isTablet: false,
    isDesktop: false,
};

export const viewportReducer = (state = defaultState, action = {}) => {
    switch (action.type) {
        case ActionTypes.SET_DEVICE_TYPE:
            switch (action.payload) {
                case DEVICE_TYPES.Desktop:
                    return {
                        deviceType: DEVICE_TYPES.Desktop,
                        isMobile: false,
                        isTablet: false,
                        isDesktop: true,
                    };
                case DEVICE_TYPES.Mobile:
                    return {
                        deviceType: DEVICE_TYPES.Mobile,
                        isMobile: true,
                        isTablet: false,
                        isDesktop: false,
                    };
                case DEVICE_TYPES.Tablet:
                    return {
                        deviceType: DEVICE_TYPES.Tablet,
                        isMobile: true,
                        isTablet: true,
                        isDesktop: false,
                    };
                default:
                    return defaultState;
            }
        default:
            return state;
    }
};
